module.exports = __webpack_public_path__ + "static/media/logo_rio.c33d6555.png";